module.exports = __webpack_public_path__ + "static/media/u35198.a82a5b2c.svg";